import { getPropertiesToTrack } from '../tracking/getPropertiesToTrack';
export class StepConfigFactory {
  static getStepConfig(stepKey, data = [], view, {
    hideProgressBar = false,
    hideStepNumber = false,
    hideBackButton = false,
    shouldShowPrivacyBanner = false,
    trackSelectedOption = false,
    isWideStep = false,
    isFramedCentredStep = true,
    getStepPropertiesToTrack = state => getPropertiesToTrack(state)[stepKey],
    waveType,
    shouldShowWavePostAccountCreation = true,
    shouldStepUseLayoutTemplate = false,
    showMessagingAboveContent = false,
    alignCentredStepAtTheTop = true
  } = {}) {
    return {
      hideProgressBar,
      hideStepNumber,
      hideBackButton,
      shouldShowPrivacyBanner,
      trackSelectedOption,
      getStepPropertiesToTrack,
      data,
      stepKey,
      view,
      waveType,
      isWideStep,
      isFramedCentredStep,
      shouldShowWavePostAccountCreation,
      shouldStepUseLayoutTemplate,
      showMessagingAboveContent,
      alignCentredStepAtTheTop
    };
  }

}